import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    modalOpen: false,
    showAnswers: false,
    isMobile: false,
    fromUrlModalActive: false
}

// form slice which the user is designing
const preview = createSlice({
    name: 'preview',
    initialState,
    reducers: {
        toggleModal: (state, { payload }) => {
            state.modalOpen = !state.modalOpen
        },
        toggleShowAnswers: (state, { payload }) => {
            state.showAnswers = !state.showAnswers
        },
        hideShowAnswers: (state, { payload }) => {
            state.showAnswers = false
        },
        updateIsMobile: (state, { payload }) => {
            state.isMobile = payload
        },
        updateFromUrlModalActive: (state, { payload }) => {
            state.fromUrlModalActive = payload.fromUrlModalActive
        },
    }
})

export const { toggleModal, toggleShowAnswers, hideShowAnswers, updateIsMobile, updateFromUrlModalActive } = preview.actions
export default preview.reducer
